export default __webpack_public_path__ + "ee794c2761d3187280e85d1500f6f530.png";